module.exports = __webpack_public_path__ + "static/media/icon-whatsapp.94a99b8c.svg";